// The gateway (functions/gateway codebase) the hosted agent checkout talks to.
// Public routes only from the browser: the cart's checkout view and the
// checkout start; the cart id in the URL is the credential.
export const GATEWAY_BASE_URL = process.env.VUE_APP_GATEWAY_BASE_URL || 'https://us-central1-thinking-of-u-prod.cloudfunctions.net/gateway';

export async function gatewayGet(path) {
  const res = await fetch(`${GATEWAY_BASE_URL}${path}`, { headers: { accept: 'application/json' } });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(body.error || `HTTP ${res.status}`), { status: res.status, details: body.details });
  return body;
}

export async function gatewayPost(path, payload) {
  const res = await fetch(`${GATEWAY_BASE_URL}${path}`, { method: 'POST', headers: { 'content-type': 'application/json', accept: 'application/json' }, body: JSON.stringify(payload || {}) });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(body.error || `HTTP ${res.status}`), { status: res.status, details: body.details });
  return body;
}
